import SVG, { CustomSVGProps } from '@/src/components/common/SVG/SVG'

export default function SVGInfo(props: CustomSVGProps) {
  return (
    <SVG width="19" height="19" viewBox="0 0 19 19" fill="none" {...props}>
      <path
        d="M8.25 4.58333H10.0833V6.41667H8.25V4.58333ZM8.25 8.25H10.0833V13.75H8.25V8.25ZM9.16667 0C4.10667 0 0 4.10667 0 9.16667C0 14.2267 4.10667 18.3333 9.16667 18.3333C14.2267 18.3333 18.3333 14.2267 18.3333 9.16667C18.3333 4.10667 14.2267 0 9.16667 0ZM9.16667 16.5C5.12417 16.5 1.83333 13.2092 1.83333 9.16667C1.83333 5.12417 5.12417 1.83333 9.16667 1.83333C13.2092 1.83333 16.5 5.12417 16.5 9.16667C16.5 13.2092 13.2092 16.5 9.16667 16.5Z"
        fill="currentColor"
      />
    </SVG>
  )
}
